import { render, staticRenderFns } from "./SettingsPlugins.vue?vue&type=template&id=25df39e0&"
import script from "./SettingsPlugins.vue?vue&type=script&lang=js&"
export * from "./SettingsPlugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports